import { DefaultUrlSerializer, UrlTree } from '@angular/router';

/**
 * Custom URL serializer to preserve/add trailing slashes.
 * Applied globally to all /stock/:id and /etf/:id routes for SEO and consistency.
 */
export class TrailingSlashUrlSerializer extends DefaultUrlSerializer {
   override parse(url: string): UrlTree {
      // 1. Check if it's a stock, etf, or platform path
      // 2. If it has a trailing slash (and no query/fragment), remove it for internal matching
      // This prevents "404 Not Found" during internal SPA navigation.
      if (url && (
         url.startsWith('/stock/') || 
         url.startsWith('/etf/') || 
         url.startsWith('/halal-collection/') ||
         url.startsWith('/halal-investing-platform/') ||
         url.startsWith('/super-investor-portfolio/')
      )) {
         const [path, ...query] = url.split(/[?#]/);
         if (path.endsWith('/') && path.length > 7) { 
            const newPath = path.slice(0, -1);
            const suffix = url.substring(path.length);
            url = newPath + suffix;
         }
      }
      return super.parse(url);
   }

   override serialize(tree: UrlTree): string {
      let url = super.serialize(tree);

      if (!url || url === '/') return url;

      // Extract path before query/fragment
      const [path, ...everythingElse] = url.split(/[?#]/);
      const suffix = url.substring(path.length);

      const isStockOrEtf = path.startsWith('/stock/') || path.startsWith('/etf/');
      const isHalalCollection = path.startsWith('/halal-collection/');
      const isPlatform = path.startsWith('/halal-investing-platform');
      const isSuperInvestor = path.startsWith('/super-investor-portfolio');

      // Add trailing slash IF:
      // 1. It's a stock, ETF, or platform route
      // 2. The path doesn't already end in a slash
      // 3. The path is more than just /stock/ or /etf/ or /halal-investing-platform/
      if ((isStockOrEtf || isHalalCollection || isPlatform || isSuperInvestor) && !path.endsWith('/') && path.length > 7) {
         return path + '/' + suffix;
      }

      return url;
   }
}